import { useReducedMotion } from "motion/react";

// Critically damped: settles cleanly, no overshoot. Default for anything
// that isn't a direct response to a drag/flick gesture.
export const springs = {
  snappy: { type: "spring", stiffness: 300, damping: 30, mass: 1 },
  bouncy: { type: "spring", stiffness: 300, damping: 18, mass: 1 },
};

export const variants = {
  fadeUp: {
    hidden: { opacity: 0, y: 16 },
    visible: { opacity: 1, y: 0, transition: springs.snappy },
  },
  staggerContainer: {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.08, delayChildren: 0.05 },
    },
  },
};

// Wraps motion's reduced-motion detection so every animated section can
// short-circuit to its settled state instead of hand-checking the media query.
export function useReducedMotionSafe() {
  return useReducedMotion();
}

// `initial={useRevealInitial(x)}` instead of `initial={x}`: under
// prefers-reduced-motion, motion treats initial={false} as "skip straight to
// the animate/whileInView target," so entrance reveals never play.
export function useRevealInitial(hiddenValue) {
  const reduced = useReducedMotionSafe();
  return reduced ? false : hiddenValue;
}
